import {  API_BASE_URL, CLIENT_ID, CLIENT_SECRET } from "../config/env";
import axios from "axios";
import { getAuth, setAuth } from "./authStorage";

const TOKEN_SCOPE = "read write";

const buildBasicAuthHeader = () =>
  "Basic " + btoa(`${CLIENT_ID}:${CLIENT_SECRET}`);

const postOAuth = async (params) => {
  const body = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null) body.append(k, String(v));
  });

  const res = await axios.post(API_BASE_URL+"/security/oauth/token", body.toString(), {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: buildBasicAuthHeader(),
    },
  });

  return res.data; // { access_token, refresh_token, expires_in, ... }
};

const ensureTokens = (data) => {
  if (!data?.access_token) throw new Error("Respuesta OAuth sin access_token");
  if (!data?.refresh_token) throw new Error("Respuesta OAuth sin refresh_token (se esperaba rotación)");
  return data;
};

export const getLogin = async ( otp, idNumber, idTransaction) => {
  const data = ensureTokens(
    await postOAuth({
      grant_type: "password",
      scope: TOKEN_SCOPE,
      otp:otp,
      idNumber:idNumber,
      idTransaction:idTransaction
    })
  );

  setAuth(data);
  return data;
};

export const refresh = async () => {
  const auth = getAuth();
  if (!auth?.refresh_token) throw new Error("No hay refresh_token en sessionStorage.");

  const data = ensureTokens(
    await postOAuth({
      grant_type: "refresh_token",
      refresh_token: auth.refresh_token,
    })
  );

  // Reemplaza TODO por lo nuevo (rotación completa)
  setAuth(data);
  return data;
};
